




































































































































































































































































































import AccordionCardWidget from "@/components/base/AccordionCardWidget.vue";
import BaseComponent from "@/components/base/BaseComponent";
import MemberAccountsGrid from "@/components/dashboard/customer-service/components/MemberAccountsGrid.vue";
import SearchMember from "@/components/dashboard/customer-service/components/SearchMember.vue";
import MemberSubAccountsGrid from "@/components/dashboard/find-member-or-employer/tabs/MemberSubAccountsGrid.vue";
import MemberBankDetails from "@/components/dashboard/process-management/addingProcess/MemberBankDetails.vue";
import MemberDetails from "@/components/dashboard/process-management/addingProcess/MemberDetails.vue";
import AppointmentBeneficiaries
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/AppointmentBeneficiaries.vue";
import ChangeInvestmentPaths
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/ChangeInvestmentPaths.vue";
import DepositInvestmentProvidentFund
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/DepositInvestmentProvidentFund.vue";
import LoanProcess from "@/components/dashboard/process-management/addingProcess/ProcessesForms/LoanProcess.vue";
import LoanRecycle from "@/components/dashboard/process-management/addingProcess/ProcessesForms/LoanRecycle.vue";
import MoneyWithdrawalEducationFund
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/MoneyWithdrawalEducationFund.vue";
import MoneyWithdrawalInvestmentProvidentFund
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/MoneyWithdrawalInvestmentProvidentFund.vue";
import MoneyWithdrawalProvidentFund
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/MoneyWithdrawalProvidentFund.vue";
import MoneyWithdrawalSelfEmployedProvidentFund
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/MoneyWithdrawalSelfEmployedProvidentFund.vue";
import MoneyWithdrawalSmallAmountProvidentFund
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/MoneyWithdrawalSmallAmountProvidentFund.vue";
import RepaymentLoan from "@/components/dashboard/process-management/addingProcess/ProcessesForms/RepaymentLoan.vue";
import UpdatingMailingType
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/UpdatingMailingType.vue";
import SuccessPage
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/withdrawal-kit/SuccessPage.vue";
import {BankAccountDetails} from "@/components/dashboard/process-management/model/BankAccountDetails";
import {
  FundType,
  MemberType,
  ProcessTypeCode
} from "@/components/dashboard/process-management/model/ProcessManagmentTypes";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {MemberCRMDetails} from "@/store/modules/customerService";
import {KeyValuePair} from "@payroll/optimus-common";
import {Component, Prop, Watch} from 'vue-property-decorator';
import {Action} from "vuex-class";

@Component({
  components: {
    AccordionCardWidget,
    SuccessPage, MemberBankDetails, MemberDetails, MemberAccountsGrid, MemberSubAccountsGrid, SearchMember
  }
})
export default class AddingNewProcessModalContent extends BaseComponent {

  @Prop() processOptions!: KeyValuePair[]

  @Action('getMemberDetails', StoreNamespace.CUSTOMER_SERVICE) getMemberDetails: any;
  @Action('getSubAccounts', StoreNamespace.CUSTOMER_SERVICE) getSubAccounts: any;
  @Action('createNewRequestByMangeCompany', StoreNamespace.PROCESSES_MANAGEMENT) createNewRequestByMangeCompany: any;
  @Action('uploadProcessAttachment', StoreNamespace.PROCESSES_MANAGEMENT) uploadProcessAttachment: any;


  private currentSelectedTabIndex: number = 0;
  private memberCRMDetails: MemberCRMDetails | null = null;
  private memberAccounts: any[] | undefined = []
  private memberFundTypes: any[] | undefined = []
  private processFormAttachment: File[] = [];
  private processAdditionalAttachmentOne: File[] = [];
  private processAdditionalAttachmentTwo: File[] = [];
  private processAdditionalAttachmentThree: File[] = [];
  private applicationFormId: string = '';
  private additionalAttachmentIdOne: string = '';
  private additionalAttachmentIdTwo: string = '';
  private additionalAttachmentIdThree: string = '';
  private memberSubAccounts: any = null
  private showSubAccountSpinner: boolean = false;
  private selectedAccountNum: string = ""
  private selectedAccount: any = null
  private bankAccountDetails: BankAccountDetails | null = null
  private processRequestObject: any = {}

  private showCreateNewProcessSpinner: boolean = false
  private showSuccessSection: boolean = false
  private memberFullName: string = ''
  private referenceNum: number = 0
  private processName: string = ''

  private enableFillingInWithdrawalDetails: boolean = true


  private tabs = [
    {
      translationKey: "processManagement.addingNewProcess.changeInvestmentPaths",
      component: ChangeInvestmentPaths,
      icon: ['fal', 'money-bill'],
      typeCode: ProcessTypeCode.CHANGE_INVESTMENT_PATHS,
      fundType: FundType.ANY
    },
    {
      translationKey: "processManagement.addingNewProcess.moneyWithdrawalEducationFund",
      component: MoneyWithdrawalEducationFund,
      icon: ['fal', 'money-bill'],
      typeCode: ProcessTypeCode.MONEY_WITHDRAWAL_EDUCATION_FUND,
      fundType: FundType.EDUCATION_FUND
    },
    {
      translationKey: "processManagement.addingNewProcess.moneyWithdrawalProvidentFund",
      component: MoneyWithdrawalProvidentFund,
      icon: ['fal', 'money-check'],
      typeCode: ProcessTypeCode.MONEY_WITHDRAWAL_PROVIDENT_FUND,
      fundType: FundType.PROVIDENT_FUND
    },
    {
      translationKey: "processManagement.addingNewProcess.moneyWithdrawalSelfEmployedProvidentFund",
      component: MoneyWithdrawalSelfEmployedProvidentFund,
      icon: ['fal', 'briefcase'],
      typeCode: ProcessTypeCode.MONEY_WITHDRAWAL_SELF_EMPLOYED_PROVIDENT_FUND,
      fundType: FundType.PROVIDENT_FUND
    },
    {
      translationKey: "processManagement.addingNewProcess.moneyWithdrawalSmallAmountProvidentFund",
      component: MoneyWithdrawalSmallAmountProvidentFund,
      icon: ['fal', 'piggy-bank'],
      typeCode: ProcessTypeCode.MONEY_WITHDRAWAL_SMALL_AMOUNT_PROVIDENT_FUND,
      fundType: FundType.PROVIDENT_FUND
    },
    {
      translationKey: "processManagement.addingNewProcess.moneyWithdrawalInvestmentProvidentFund",
      component: MoneyWithdrawalInvestmentProvidentFund,
      icon: ['fal', 'chart-line'],
      typeCode: ProcessTypeCode.MONEY_WITHDRAWAL_INVESTMENT_PROVIDENT_FUND,
      fundType: FundType.INVESTMENT_PROVIDENT_FUND
    },
    {
      translationKey: "processManagement.addingNewProcess.updatingMailingTypeForNoticesAndUpdates",
      component: UpdatingMailingType,
      icon: ['fal', 'envelope'],
      typeCode: ProcessTypeCode.UPDATING_MAILING_TYPE_FOR_NOTICES_AND_UPDATES,
      fundType: FundType.ANY
    },
    {
      translationKey: "processManagement.addingNewProcess.loanProcess",
      component: LoanProcess,
      icon: ['fal', 'file-alt'],
      typeCode: ProcessTypeCode.LOAN_PROCESS,
      fundType: FundType.ANY
    },
    {
      translationKey: "processManagement.addingNewProcess.loanRecycle",
      component: LoanRecycle,
      icon: ['fal', 'recycle'],
      typeCode: ProcessTypeCode.LOAN_RECYCLE,
      fundType: FundType.ANY
    },
    {
      translationKey: "processManagement.addingNewProcess.depositInvestmentProvidentFund",
      component: DepositInvestmentProvidentFund,
      icon: ['fal', 'coins'],
      typeCode: ProcessTypeCode.DEPOSIT_INVESTMENT_PROVIDENT_FUND,
      fundType: FundType.INVESTMENT_PROVIDENT_FUND
    },
    {
      translationKey: "processManagement.addingNewProcess.repaymentLoan",
      component: RepaymentLoan,
      icon: ['fal', 'hand-holding-usd'],
      typeCode: ProcessTypeCode.REPAYMENT_LOAN,
      fundType: FundType.ANY
    },
    {
      translationKey: "processManagement.addingNewProcess.appointmentBeneficiaries",
      component: AppointmentBeneficiaries,
      icon: ['fal', 'user-plus'],
      typeCode: ProcessTypeCode.APPOINTMENT_BENEFICIARIES,
      fundType: FundType.ANY
    }
  ];

  @Watch('')


  private onSelectedMember(member: any) {

    this.getMemberDetails({
      pathVariable: member.id,
      requestorCallback: this
    })
  }

  private initUploadedAttachment(data: any) {

    switch (data.attachmentType) {
      case 'processFormAttachment':
        this.applicationFormId = data.id
        break
      case 'processAdditionalAttachmentOne':
        this.additionalAttachmentIdOne = data.id
        break
      case 'processAdditionalAttachmentTwo':
        this.additionalAttachmentIdTwo = data.id
        break
      case 'processAdditionalAttachmentThree':
        this.additionalAttachmentIdThree = data.id
        break
    }
  }

  onSuccess(data?: any, requestName?: string, message?: string) {
    switch (requestName) {
      case 'getMemberDetails':
        this.memberCRMDetails = data;
        this.memberAccounts = []
        if (this.memberCRMDetails) {
          this.memberAccounts = this.memberCRMDetails.accountsList
          this.memberFundTypes = this.memberCRMDetails.fundTypeList
        }
        break;

      case 'findMembersOrEmployersFor/subAccounts':
        this.showSubAccountSpinner = false;
        this.memberSubAccounts = data
        this.memberSubAccounts.results.forEach((subAccount: any) => {
          if (this.isSubAccountSelectable) {
            subAccount.selectWithdrawalOption = false;
          } else {
            subAccount.selectWithdrawalOption = true;
          }
        })
        break;

      case 'uploadProcessAttachment':
        this.initUploadedAttachment(data)
        break;

      case 'createNewRequestByMangeCompany':
        this.showCreateNewProcessSpinner = false
        this.showSuccessSection = true;
        this.memberFullName = data.memberFullName
        this.referenceNum = data.referenceNum
        this.processName = data.processName
    }
  }

  private handleTabChange(tabIndex: number) {
    this.selectedAccount = null
    this.memberSubAccounts = null
    this.processFormAttachment = []
    this.currentSelectedTabIndex = tabIndex
  }


  onInputFile(files: any[], attachmentType: string) {
    if (files.length === 0) {
      return
    }

    const formData: FormData = new FormData();
    formData.append('file', files[0].file)
    formData.append('type', files[0].type);
    formData.append('attachmentType', attachmentType);


    this.uploadProcessAttachment({requestorCallback: this, formData});
  }

  private onRemovedAttachmentClicked() {
    this.processFormAttachment = [];

  }

  private onSelectedMemberAccount(accountDetails: any) {
    this.memberSubAccounts = null
    this.selectedAccountNum = accountDetails.accountNum
    this.selectedAccount = accountDetails
    this.showSubAccountSpinner = true

    this.getSubAccounts({
      pathVariable: accountDetails.accountNumHashed,
      requestorCallback: this
    })
  }

  private handleAddOrRemoveSubAccount(subAccount: any) {

    if (!this.isSubAccountSelectable) {
      return
    }

    const subAccountExist = this.memberSubAccounts.results.find(
        (currentItem: any) => currentItem === subAccount
    );

    if (subAccountExist) {
      const index = this.memberSubAccounts.results.indexOf(subAccountExist);
      subAccountExist.selectWithdrawalOption = !subAccountExist.selectWithdrawalOption;

      this.$set(this.memberSubAccounts.results, index, subAccountExist);
    }
  }

  private handleSelectAllSubAccount(isSelect: boolean) {
    this.memberSubAccounts.results.forEach((subAccount: any, index: number) => {
      subAccount.selectWithdrawalOption = isSelect
      this.$set(this.memberSubAccounts.results, index, subAccount);
    });
  }

  get getMemberSubAccountResults() {
    if (this.memberSubAccounts && this.memberSubAccounts.results) {
      return this.memberSubAccounts.results
    }

    return []
  }

  handleProcessRequestChanged(requestObject: any) {
    this.processRequestObject = requestObject
  }

  handleBankDetailsChanged(bankAccountDetails: BankAccountDetails) {
    this.bankAccountDetails = bankAccountDetails
  }

  submitProcess() {
    const pathVariable = this.tabs[this.currentSelectedTabIndex].typeCode

    const selectedSubAccounts = this.memberSubAccounts.results
        .filter((subAccount: any) => subAccount.selectWithdrawalOption)
        .map((subAccount: any) => {
          return this.mapMemberSubAccountsToOptionAccount(subAccount);
        });

    let requestBody = {
      accountNumber: this.selectedAccountNum,
      idNumber: this.memberCRMDetails?.personalId,
      employerName: this.selectedAccount.employerName,
      ...this.processRequestObject
    }

    if (this.isSubAccountSelectable) {
      requestBody = {
        ...requestBody,
        optionAccounts: selectedSubAccounts,
        bankName: this.bankAccountDetails?.bank.description,
        bankBranchName: this.bankAccountDetails?.branch.description,
        bankAccountNumber: this.bankAccountDetails?.accountNum,
        attachments: {
          applicationForm: this.applicationFormId,
          additionalAttachmentOne: this.additionalAttachmentIdOne,
          additionalAttachmentTwo: this.additionalAttachmentIdTwo,
          additionalAttachmentThree: this.additionalAttachmentIdThree
        }
      };
    } else {
      requestBody = {
        ...requestBody,
        changeInvestmentAttachment: {
          applicationForm: this.applicationFormId,
          additionalAttachmentOne: this.additionalAttachmentIdOne,
          additionalAttachmentTwo: this.additionalAttachmentIdTwo,
          additionalAttachmentThree: this.additionalAttachmentIdThree
        }
      };
    }

    this.showCreateNewProcessSpinner = true;

    this.createNewRequestByMangeCompany({
      requestorCallback: this,
      pathVariable,
      requestBody: {...requestBody}
    })
  }

  private mapMemberSubAccountsToOptionAccount(subAccount: any) {
    return {
      selectWithdrawalOption: subAccount.selectWithdrawalOption,
      financeCode: subAccount.financeCode,
      fundName: subAccount.fundName,
      accountNum: subAccount.memberFundAndAccount,
      employerName: subAccount.employerName,
      moneyTypeStr: subAccount.moneyType,
      seniorityEndDate: subAccount.seniorityEndDate,
      accountBalanceStr: subAccount.accountBalance,
      accountBalanceMoneyFormat: subAccount.accountBalance
    }
  }

  get filteredMemberAccounts() {
    if (!this.memberAccounts) {
      return [];
    }

    const fundType = this.filteredTabs[this.currentSelectedTabIndex].fundType;

    if (fundType === FundType.ANY) {
      return this.memberAccounts
    }


    return this.memberAccounts.filter((memberAccount: any) => memberAccount.fundType === fundType);
  }

  get isSubAccountSelectable() {
    const typeCode = this.filteredTabs[this.currentSelectedTabIndex].typeCode;


    return typeCode !== ProcessTypeCode.CHANGE_INVESTMENT_PATHS
  }

  onClickGoBack() {
    this.memberCRMDetails = null
  }

  get filteredTabs() {
    const processCodesOptions = this.processOptions.map((processType: any) => processType.value);
    const includeProvidentFund = processCodesOptions.includes(ProcessTypeCode.MONEY_WITHDRAWAL_PROVIDENT_FUND + '')


    return this.tabs.filter((tab: any) => {
      if (processCodesOptions.includes(tab.typeCode + '')) {
        return true;
      }

      if (includeProvidentFund) {

        if (tab.typeCode === ProcessTypeCode.MONEY_WITHDRAWAL_SMALL_AMOUNT_PROVIDENT_FUND) {
          return true;
        }

        if (tab.typeCode === ProcessTypeCode.MONEY_WITHDRAWAL_SELF_EMPLOYED_PROVIDENT_FUND) {
          return true;
        }
      }
    })
  }

  handleClosePopup() {
    this.$emit('closePopup')
  }

  handleCreateNewProcess() {
    this.memberCRMDetails = null
    this.processRequestObject = {}
    this.showSuccessSection = false
  }

  handleDisableFillingInWithdrawalDetails(checked: boolean) {
    if (!checked) {

      switch (this.tabs[this.currentSelectedTabIndex].typeCode) {
        case ProcessTypeCode.MONEY_WITHDRAWAL_SELF_EMPLOYED_PROVIDENT_FUND:
          this.processRequestObject = {
            memberStatusType: MemberType.SELF_EMPLOYED
          }
          break;

        case ProcessTypeCode.MONEY_WITHDRAWAL_SMALL_AMOUNT_PROVIDENT_FUND:
          this.processRequestObject = {
            memberStatusType: MemberType.SMALL_AMOUNT
          }
          break;

        case ProcessTypeCode.MONEY_WITHDRAWAL_PROVIDENT_FUND:
          this.processRequestObject = {
            memberStatusType: MemberType.EMPLOYEE
          }
          break;

        default:
          this.processRequestObject = {}
      }
    }

  }
}
